import { render, staticRenderFns } from "./DispensaPrazos.vue?vue&type=template&id=a03b4ef2&"
import script from "./DispensaPrazos.vue?vue&type=script&lang=js&"
export * from "./DispensaPrazos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports